import { Link } from 'react-router-dom';
import './componets.scss';

export const BtnFuture = ({ url, text }) => {
    return (
        <Link to={url} className='btn-furure'>
            {text}
        </Link>
    )
}